// C4 (web): granulaire server-push-instellingen, zelfde datamodel/conventie
// als de C3-app-implementatie (src/services/database.js). Ontbrekende rij =
// alles aan — zelfde COALESCE-afspraak als de C2-send-poort. Nooit een
// partiële patch: savePushPreferences upsert altijd de volledige rij, zodat
// het togglen van één categorie de overige nooit terugzet naar hun
// kolomdefault.
const DEFAULT_PUSH_PREFERENCES = {
  lessons_schedule: true,
  pt_appointments: true,
  billing: true,
  agreements: true,
  coach_messages: true,
  client_activity: true,
};

export async function getPushPreferences(supabase, userId) {
  const { data, error } = await supabase
    .from('push_preferences')
    .select('lessons_schedule, pt_appointments, billing, agreements, coach_messages, client_activity')
    .eq('user_id', userId)
    .maybeSingle();
  if (error) throw error;
  return data || { ...DEFAULT_PUSH_PREFERENCES };
}

export async function savePushPreferences(supabase, userId, preferences) {
  const { error } = await supabase
    .from('push_preferences')
    .upsert({ user_id: userId, ...preferences });
  if (error) throw error;
}
